export default "__VITE_ASSET__D0Mw0qqX__"